import { CONTACT, OFFICES } from "../../data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#27272a] pt-16">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row justify-between gap-10 pb-16">
          <div className="max-w-sm">
            <div className="flex items-center gap-4 mb-4">
              <img src="/qualiz-logo.png" alt="Qualiz Material Testing & Research Centre logo" className="h-16 w-16 object-contain" />
              <span className="font-heading font-black text-2xl tracking-tighter uppercase">Qualiz</span>
            </div>
            <p className="text-[#8e8e93] text-sm font-light leading-relaxed">
              Qualiz Material Testing and Research Centre Pvt. Ltd. — NABL accredited laboratory. Your trusted
              testing partner for resilient infrastructure.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8e8e93] mb-2">Contact</span>
            <a href={`mailto:${CONTACT.email}`} className="text-[#f4f4f5] hover:text-[#ff4500] transition-colors text-sm">{CONTACT.email}</a>
            {CONTACT.phones.map((p) => (
              <a key={p} href={`tel:${p}`} className="text-[#f4f4f5] hover:text-[#ff4500] transition-colors font-mono text-sm">+91 {p}</a>
            ))}
          </div>

          <div className="flex flex-col gap-2">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8e8e93] mb-2">Navigate</span>
            {["Services", "About", "Approach", "Locations", "Contact"].map((l) => (
              <a key={l} href={`#${l.toLowerCase()}`} className="text-[#f4f4f5] hover:text-[#ff4500] transition-colors text-sm">{l}</a>
            ))}
          </div>
        </div>
      </div>

      {/* Massive typographic logo */}
      <div className="overflow-hidden border-t border-[#27272a]">
        <h2 className="font-heading font-black uppercase tracking-tighter leading-none text-center text-[#111111] select-none text-[24vw] md:text-[22vw] -mb-[3vw] md:-mb-[3.5vw]">
          QUALIZ
        </h2>
      </div>

      <div className="border-t border-[#27272a]">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-[#5a5a5f] font-mono text-[10px] tracking-[0.15em] uppercase">
          <span>© {new Date().getFullYear()} Qualiz Material Testing & Research Centre Pvt. Ltd.</span>
          <span>{OFFICES.map((o) => o.city).join(" · ")}</span>
        </div>
      </div>
    </footer>
  );
}
